import { useContext, useEffect } from 'react';
import constants from '../../constants';
import Select from '../../ui/Select';
import { formatLclFcl, formatShipmentType, unFormatLclFcl } from './utils/formatUtils';
import { formatDateTime } from '../../dateUtils';

import cntrYellow from '../../img/cntr-tracking-rq-12-amber.svg';
import cntrGreen from '../../img/cntr-tracking-rq-12-green.svg';
import cntrBlue from '../../img/cntr-tracking-rq-12-blue.svg';
import cntrRed from '../../img/cntr-tracking-rq-12-red.svg';
import cntrIot from '../../img/manifest_tracking.svg';
import ApplicationContext from '../../ApplicationContext';
import { getFmsGlobal } from '../../globals';
import { JobNames } from '../../framework.core/JobNames';
import { toTitleCase } from '../../util';

export function BillingsRenderer({ cell }: any) {
  let tempBillingsTooltip = '';
  switch (cell.value) {
    case 'I':
      tempBillingsTooltip = 'Issued';
      break;
    case 'E':
      tempBillingsTooltip = 'Empty';
      break;
    case 'P':
      tempBillingsTooltip = 'Pending';
      break;
  }
  return (
    <div id={`billings-renderer-${cell.column.dataIndex}`} className="ifms-table-default" data-tooltip={tempBillingsTooltip}>{cell.value}</div>
  );
}

export function PeriodRenderer({ cell }: any) {
  return (
    <div className="ifms-table-default" data-tooltip="Period">{cell.value}</div>
  );
}


export function RecognizedRenderer({ cell }: any) {
  return (
    <div id="recognized_renderer" className="ifms-table-default" data-tooltip="Recognize">{cell.value}</div>
  );
}

export function TrackEventNameRenderer({ cell, row, data }: any) {
  const l = data[row.index];
  const lastEventDate = (l as any).lastEventDate as string;

  return (
    <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left capitalize">
      {cell.value} {formatDateTime(lastEventDate)}
    </div>
  );
}

export function ShipmentTypeRenderer({ cell }: any) {
  return (
    <div className="ifms-table-default" >{formatShipmentType(cell.value)}</div>
  );
}

export function LastEventRenderer({ cell, row, data, jobName }: any) {
  const l = data[row.index];
  const lastEventDate = (l as any).lastEventDate as string;
  const trDate = (l as any).trDate as string;
  const appContext = useContext(ApplicationContext);
  const trStatus = cell.value;
  const lastEvent = ((l as any).lastEvent as string);
  const fmsGlobal = getFmsGlobal(); 
  let imgSrc = null;

  let tooltip = '';
  let displayText = '';
  let displayDateTime = '';
  let id = '';
  let params = ''

  switch (jobName) {
    case JobNames.OIMbl:
    case JobNames.OEMbl:
    case JobNames.OtherOP:
      params = `&mbl=${cell.row.original.mblNo}`;
      break;
    case JobNames.OIHbl:
    case JobNames.OEHbl:
      params = `&hbl=${cell.row.original.hblNo}`;
      break;
    case JobNames.OIContainer:
    case JobNames.OEContainer:
    case JobNames.OtherContainer:
    case JobNames.RptCustomerShipment:
    case JobNames.AllContainer:
      params = `&cntr=${cell.row.original.containerNo}`;
      break;
  }

  let link = `https://trackinginfo.suntekscm.com/?licid=${fmsGlobal.AcmeID}${params}`;
  
  if ((cell.row.original.trType === 'M' || cell.row.original.trType === 'C')) {
    switch (trStatus) {
      case 'Q':
        displayText = 'Start to Request';
        displayDateTime = trDate;
        tooltip = `${displayText} ${formatDateTime(displayDateTime)}`;
        imgSrc = cntrYellow;
        id = 'cntrYellowIcon';
        break;
      case 'failed':
        displayText = 'Invalid or Error';
        displayDateTime = trDate;
        tooltip = `${(l as any).trStatusDesc as string} ${formatDateTime(displayDateTime)}`;
        imgSrc = cntrRed;
        id = 'cntrRedIcon';
        break;
      case 'tracking_stopped':
        displayText = lastEvent;
        displayDateTime = lastEventDate;
        tooltip = `${displayText} ${formatDateTime(displayDateTime)}`;
        imgSrc = cntrBlue;
        id = 'cntrBlueIcon';
        break;
      case 'pending':
        displayText = 'Pending';
        displayDateTime = lastEventDate;
        tooltip = '';
        imgSrc = cntrGreen;
        id = 'cntrGreenIcon';
        break;
      case 'awaiting_manifest':
        displayText = 'Awaiting Manifest';
        displayDateTime = lastEventDate;
        tooltip = '';
        imgSrc = cntrGreen;
        id = 'cntrGreenIcon';
        break;
      default:
        displayText = lastEvent;
        displayDateTime = lastEventDate;
        imgSrc = cntrGreen;
        id = 'cntrGreenIcon';
        break;
    }
    if (!displayText) {
      displayText = 'Not received event';
      tooltip = '';
    }
    if (tooltip.includes('null')) tooltip = '';

    if (displayText.includes('eta')) displayText = displayText.replaceAll('eta', 'ETA');
    else if (displayText.includes('lfd')) displayText = displayText.replaceAll('lfd', 'LFD');
    else if (displayText.includes('full')) displayText = displayText.replaceAll('full', 'Gate');
    else if (displayText.includes('pod')) displayText = displayText.replaceAll('pod', 'POD');

    tooltip = `${toTitleCase(displayText)} ${formatDateTime(displayDateTime)}`;

    return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left capitalize"
      style={{ display: 'flex', alignItems: 'center' }}
      data-tooltip={tooltip} >
      <img style={{ cursor: 'pointer', float: 'left', marginRight:'4px' }} id={id} src={imgSrc} alt='' onClick={() => {
        window.open(link);
      }} />
      <div style={{ paddingLeft: '5px' }}>
        {displayText} {formatDateTime(displayDateTime)}
      </div>
    </div>
  } else {
    return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left capitalize" style={{ display: 'flex', alignItems: 'center' }}>
    </div>
  }
}

export function ShipmentTypeFilterRenderer({ value, onChange, onEnter }: any) {
  return (
    <Select
      name='ifms-filter-shipmentType-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { label: 'D - Direct Shipment', value: 'D' },
        { label: 'ID - InDirect Shipment', value: 'ID' },
        { label: 'A.EDI', value: 'A.EDI' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

export function OIShipmentTypeFilterRenderer({value, onChange, onEnter}: any){
    return (
    <Select
      name='ifms-filter-OIshipmentType-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { label: 'D - Direct Shipment', value: 'D' },
        { label: 'ID - InDirect Shipment', value: 'ID' },
        { label: 'AMS', value: 'AMS' },
        { label: 'ISF', value: 'ISF' },
        { label: 'A.EDI', value: 'A.EDI' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

export function LclFclRenderer({ cell }: any) {
  return (
    <div className="ifms-table-default">{formatLclFcl(cell.value)}</div>
  );
}

export function LclFclFilterRenderer({ value, onChange, onEnter }: any) {
  useEffect(() => {
    if (value !== unFormatLclFcl(value)) {
      onChange(unFormatLclFcl(value));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Select
      name='ifms-filter-cargo-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { value: 'L', label: 'Consol' },
        { value: 'F', label: 'FCL' },
        { value: 'O', label: 'LCL' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

export function BillInvoiceCrdbFilterRenderer({ value, onChange, onEnter }: any) {
  return (
    <Select
      name='ifms-filter-billInvoiceCrdb-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { value: 'E', label: 'E - Empty' },
        { value: 'I', label: 'I - Issued' },
        { value: 'P', label: 'P - Pending' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

export function RecognizedFilterRenderer({ value, onChange, onEnter }: any) {
  return (
    <Select
      value={value === null ? 'R' : value}
      name='ifms-filter-recognize-select'
      onChange={e => onChange(e.target.value)}
      items={[
        { value: '', label: '' },
        { value: 'R', label: 'Recognize' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

export function TaxIdTypeFilterRenderer({ value, onChange, onEnter }: any) {
  return (
    <Select
      name='ifms-filter-taxIdType-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { value: 'E', label: 'EIN - IRS Number' },
        { value: 'C', label: 'CBP - CBP Assigned Number' },
        { value: 'S', label: 'SSN - Social Security Number' },
        { value: 'O', label: 'OC - Organization Code' },
        { value: 'U', label: 'USCI - United Social Credit Identifier' },
        { value: 'R', label: 'EORI - Economic Operator Reg. ID' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

//Empty Renderer
export function StatusNotUseFileLockedRenderer({ value, onChange, onEnter }: any) {
  return (
    <Select
      name='ifms-filter-statusNotUse-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

export function DraftFilterRenderer({ value, onChange, onEnter }: any) {
  return (
    <Select
      name='ifms-filter-draft-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { value: '', label: '' },
        { value: 'D', label: 'D - Draft' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

export function VoidFilterRenderer({ value, onChange, onEnter }: any) {
  return (
    <Select
      name='ifms-filter-void-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { value: '', label: '' },
        { value: 'V', label: 'V - Void' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

export function InactiveFilterRenderer({ value, onChange, onEnter }: any) {
  return (
    <Select
      name='ifms-filter-inactive-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { value: '', label: '' },
        { value: 'V', label: 'V - Inactive' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

export function CTypeFilterRenderer({ value, onChange, onEnter }: any) {
  return (
    <Select
      name='ifms-filter-cType-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { value: 'C', label: 'Customer' },
        { value: 'ST', label: 'Ship To' },
        { value: 'SF', label: 'Ship From' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

// export function HeaderTooltipRenderer(caption: string, tooltip: string) {
//   return (
//     <div data-tooltip-position="listview-header" style={{ width: '100%' }} data-tooltip={tooltip}>{caption}</div>
//   );
// }

/**
 * Type Filter renderer for Bill, Invoice, CrDb list screens
 *
 * @export
 * @param {*} {opType, value, onChange}
 * @return {*} 
 */
export function BicTypeFilterRenderer({ opType, value, onChange, onEnter }: any) {
  const items = [];
  switch (opType) {
    case constants.opTypes.oceanImport:
      items.push(...[
        { label: 'OIM', value: 'OIM' },
        { label: 'OIH', value: 'OIH' },
      ]);
      break;
    case constants.opTypes.oceanExport:
      items.push(...[
        { label: 'OEM', value: 'OEM' },
        { label: 'OEH', value: 'OEH' },
      ]);
      break;
    case constants.opTypes.airImport:
      items.push(...[
        { label: 'AIM', value: 'AIM' },
        { label: 'AIH', value: 'AIH' },
      ]);
      break;
    case constants.opTypes.airExport:
      items.push(...[
        { label: 'AEM', value: 'AEM' },
        { label: 'AEH', value: 'AEH' },
      ]);
      break;
    case constants.opTypes.otherShipment:
      items.push(...[
        { label: 'OTH', value: 'OTH' },
      ]);
      break;
    case constants.opTypes.warehousing:
      items.push(...[
        { label: '', value: '' },
        { label: 'WHR', value: 'WHR' },
        { label: 'WHS', value: 'WHS' },
      ]);
      break;
    default:
      items.push(...[
        { label: 'AIM', value: 'AIM' },
        { label: 'AIH', value: 'AIH' },
        { label: 'AEM', value: 'AEM' },
        { label: 'AEH', value: 'AEH' },
        { label: 'OIM', value: 'OIM' },
        { label: 'OIH', value: 'OIH' },
        { label: 'OEM', value: 'OEM' },
        { label: 'OEH', value: 'OEH' },
        { label: 'OTH', value: 'OTH' },
        { label: 'WHR', value: 'WHR' },
        { label: 'WHS', value: 'WHS' },
      ]);
      break;
  }
  return (
    <Select
      name='ifms-filter-bicType-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={items}
      applySearchWithEnter={onEnter}
    />
  );
}

export function RQFilterRenderer({ value, onChange, onEnter }: any) {
  return (
    <>
    <Select
      name='ifms-filter-rqcol-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
         { value: '', label: '' },
         { value: 'Q', label: 'Start to Request', icon: cntrYellow  },
         { value: 'created', label: 'Under Movement', icon: cntrGreen },
         { value: 'iotTracker', label: 'IoT Tracker', icon: cntrIot },
         { value: 'tracking_stopped', label: 'End of Tracking', icon: cntrBlue },
         { value: 'failed', label: 'Invalid or Error', icon: cntrRed },
      ]}
      applySearchWithEnter={onEnter}
    />
    </>
  );
}

export function changeRQEvent(searchValue: string, showLabel = false){
   let eventName = "";
   if(searchValue !== null){
    let value = searchValue.toLocaleLowerCase();
    if (value.includes("empty out")) eventName = "Empty Out";
    else if (value.includes("gate in") || value.includes("full in")) {
      if(showLabel) eventName = "Gate In";
      else eventName = "Full In";
    }
    else if (value.includes("vessel loaded")) eventName = "Vessel Loaded";
    else if (value.includes("vessel departed")) eventName = "Vessel Departed";
    else if (value.includes("eta change")) eventName = "ETA Change";
    else if (value.includes("transshipment arrived")) eventName = "Transshipment Arrived";
    else if (value.includes("transshipment discharged")) eventName = "Transshipment Discharged";
    else if (value.includes("transshipment loaded")) eventName = "Transshipment Loaded";
    else if (value.includes("transshipment departed")) eventName = "Transshipment Departed";
    else if (value.includes("vessel arrived")) eventName = "Vessel Arrived";
    else if (value.includes("vessel discharged")) eventName = "Vessel Discharged";
    else if (value.includes("pickup lfd") || value.includes("Pickup LFD")) eventName = "Pickup LFD";
    else if (value.includes("available for pickup")) eventName = "Available For Pickup";
    else if (value.includes("pickup lfd")) eventName = "Pickup LFD";
    else if (value.includes("gate out") || value.includes("full out")){
      if(showLabel) eventName = "Gate Out";
      else eventName = "Full Out";
    }    
    else if (value.includes("empty in")) eventName = "Empty In";   
    else if (value.includes("rail loaded")) eventName = "Rail Loaded";    
    else if (value.includes("rail departed")) eventName = "Rail Departed";    
    else if (value.includes("rail arrived")) eventName = "Rail Arrived";    
    else if (value.includes("rail unloaded")) eventName = "Rail Unloaded";    
    }
   return eventName;
 }


export function RQFilterEventRenderer({ value, onChange, onEnter }: any) {


    const items = [
        { value: '', label: ''},
        { value: 'Empty Out', label: 'Empty Out', icon: cntrGreen, iconHeight: '12px'},
        { value: 'Full In', label: 'Gate In', icon: cntrGreen, iconHeight: '12px'},
        { value: 'Vessel Loaded', label: 'Vessel Loaded', icon: cntrGreen, iconHeight: '12px'},
        { value: 'Vessel Departed', label: 'Vessel Departed', icon: cntrGreen, iconHeight: '12px'},
        { value: 'ETA Change', label: 'ETA Change', icon: cntrGreen, iconHeight: '12px'},
        { value: 'Transshipment Arrived', label: 'Transshipment Arrived', icon: cntrGreen, iconHeight: '12px'},
        { value: 'Transshipment Discharged', label: 'Transshipment Discharged', icon: cntrGreen, iconHeight: '12px'},
        { value: 'Transshipment Loaded', label: 'Transshipment Loaded', icon: cntrGreen, iconHeight: '12px'},
        { value: 'Transshipment Departed', label: 'Transshipment Departed', icon: cntrGreen, iconHeight: '12px'},
        { value: 'Vessel Arrived', label: 'Vessel Arrived', icon: cntrGreen, iconHeight: '12px'},
        //{ value: 'Vessel Berthed', label: 'Vessel Berthed'},
        { value: 'Vessel Discharged', label: 'Vessel Discharged', icon: cntrGreen, iconHeight: '12px'},
        //{ value: 'Holds At Pod Terminal', label: 'Holds At Pod Terminal'},
        //{ value: 'Pod Terminal Changed', label: 'Pod Terminal Changed'},
        //{ value: 'Pod Terminal', label: 'Pod Terminal'},
        { value: 'Pickup LFD', label: 'Pickup LFD', icon: cntrGreen, iconHeight: '12px'},
        //{ value: 'Pickup Appointment At', label: 'Pickup Appointment At'},
        { value: 'Available For Pickup', label: 'Available For Pickup', icon: cntrGreen, iconHeight: '12px'},
        { value: 'Full Out', label: 'Gate Out', icon: cntrGreen, iconHeight: '12px'},
        { value: 'Empty In', label: 'Empty In', icon: cntrBlue, iconHeight: '12px'},
        { value: 'Rail Loaded', label: 'Rail Loaded', icon: cntrGreen, iconHeight: '12px'},
        { value: 'Rail Departed', label: 'Rail Departed', icon: cntrGreen, iconHeight: '12px'},
        { value: 'Rail Arrived', label: 'Rail Arrived', icon: cntrGreen, iconHeight: '12px'},
        { value: 'Rail Unloaded', label: 'Rail Unloaded', icon: cntrGreen, iconHeight: '12px'},
    ]



  return (
    <>
    <Select
      name='ifms-filter-rqcol-select'
      value={value !== null ? changeRQEvent(value) : ""}
      items={items}
      onChange={e => onChange(e.target.value)}
      applySearchWithEnter={onEnter}
    />
    </>
  );
}


  export function MemoOpTypeRenderer({ opType, value, onChange, onEnter }: any) {
  return (
    <Select
      name='ifms-filter-memooptype-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { label: 'Board', value : 'Board'},
        { label: 'AIM', value: 'AIM' },
        { label: 'AIH', value: 'AIH' },
        { label: 'AEM', value: 'AEM' },
        { label: 'AEH', value: 'AEH' },
        { label: 'OIM', value: 'OIM' },
        { label: 'OIH', value: 'OIH' },
        { label: 'OEM', value: 'OEM' },
        { label: 'OEH', value: 'OEH' },
        { label: 'OTH', value: 'OTH' },
        { label: 'F/R', value : 'F/R'},
        { label: 'WHR', value: 'WHR' },
        { label: 'WHS', value: 'WHS' },
        { label: 'INV', value: 'INV'},
        { label: 'BIL', value: 'BIL'},
        { label: 'G.INV', value: 'G.INV'},
        { label: 'G.BIL', value: 'G.BIL'},
        { label: 'CrDb', value: 'CrDb'},
        { label: 'C. Pay', value: 'C. Pay'},
        { label: 'B. Pay', value: 'B. Pay'},
        { label: 'CC Pay', value: 'CC Pay'},
        { label: 'Agent. S', value: 'Agent. S'},
        { label: 'Payroll', value: 'Payroll'},
        { label: 'Company', value: 'Company'},
        { label: 'OICNTR', value: 'OICNTR'},
        { label: 'OECNTR', value: 'OECNTR'},
        { label: 'OTCNTR', value: 'OTCNTR'},
        { label: 'OIQUOTE', value: 'OIQUOTE'},
        { label: 'OEQUOTE', value: 'OEQUOTE'},
        { label: 'AIQUOTE', value: 'AIQUOTE'},
        { label: 'AEQUOTE', value: 'AEQUOTE'},
        { label: 'OTQUOTE', value: 'OTQUOTE'},
        { label: 'BankRecon', value: 'BankRecon'},
        { label: 'BankTransfer', value: 'BankTransfer'},
        { label: 'TaxReturn', value: 'TaxReturn'}
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}